import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { fetchApi } from '../../services/api';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    newChild: NewChildData;
    validation: boolean;
    isLoading: boolean;
}

type NewChildData = {
    FirstName: string;
    LastName: string;
    BirthDate: Date | null;
    Gender: number | null;
    Healthcard: string;
}

export default class Copy extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false,
            validation: false,
            newChild: {
                FirstName: '',
                LastName: '',
                BirthDate: null,
                Gender: null,
                Healthcard: ''
            },
        }

        this.copy = this.copy.bind(this);
        this.setGender = this.setGender.bind(this);
    }

    public render() {
        return <div>
            <DocumentTitle title='Copy Child' />
            <form className="k-form">
                <h5>New Child information</h5>
                <div className="card">
                    <div className="card-body">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">First and Last Name<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <input
                                className="form-control"
                                type="text"
                                name={`FirstName`}
                                placeholder="First Name"
                                value={this.state.newChild.FirstName}
                                onChange={(e) => this.updateChildState({ FirstName: e.target.value })}
                            />
                            <input
                                className="form-control"
                                type="text"
                                name={`LastName`}
                                placeholder="Last Name"
                                value={this.state.newChild.LastName}
                                onChange={(e) => this.updateChildState({ LastName: e.target.value })}
                            />
                        </div>
                        {this.state.validation && !this.state.newChild.FirstName && !this.state.newChild.LastName && <p className="error-msg">First and Last Name are Required</p>}
                        {this.state.validation && !this.state.newChild.FirstName && this.state.newChild.LastName && <p className="error-msg">First Name is Required</p>}
                        {this.state.validation && this.state.newChild.FirstName && !this.state.newChild.LastName && <p className="error-msg">Last Name is Required</p>}
                        {this.state.validation && this.state.newChild.FirstName && this.state.newChild.LastName && <br/> || !this.state.validation && <br/>}
                        <div className="k-form-field" onChange={this.setGender}>
                            <span>Gender<span style={{ color: '#dc3545' }}>*</span></span>
                            <input
                                type="radio"
                                name="Child.Gender"
                                id="Child.Female"
                                value="1"
                                className="k-radio"
                                checked={this.state.newChild.Gender === 1}
                            />
                            <label className="k-radio-label" htmlFor="Child.Female">Female</label>
                            <input
                                type="radio"
                                name="Child.Gender"
                                id="Child.Male"
                                value="0"
                                className="k-radio"
                                checked={this.state.newChild.Gender === 0}
                            />
                            <label className="k-radio-label" htmlFor="Child.Male">Male</label>
                            {this.state.validation && this.state.newChild.Gender !== 0 && this.state.newChild.Gender !== 1 && <div><p className="error-msg">Gender is Required</p></div>}
                        </div>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Date of Birth<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <DatePicker
                                format="MM/dd/yyyy"
                                max={moment().toDate()}
                                name={`BirthDate`}
                                formatPlaceholder="formatPattern"
                                value={this.state.newChild.BirthDate}
                                onChange={(e) => this.updateChildState({ BirthDate: e.value })}
                            />
                        </div>
                        {(this.state.validation && !this.state.newChild.BirthDate) ? <p className="error-msg">Birth Date is Required</p> : <br/>}
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Health Card Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="0000-000-000-LL"
                                name={`Healthcard`}
                                placeholder="0000-000-000-AA"
                                value={this.state.newChild.Healthcard}
                                onChange={(e) => this.updateChildState({ Healthcard: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                        {(this.state.validation && (!this.state.newChild.Healthcard || this.state.newChild.Healthcard.length < 15)) ? <p className="error-msg">Health Card is Required</p> : <br/>}
                    </div>
                </div>
                <br />
                {!this.state.isLoading && <Button onClick={this.copy} primary>Copy Child</Button>}
            </form>
        </div>
    }

    private setGender(e: any) {
        this.updateChildState({ Gender: parseInt(e.target.value) });
    }

    private updateChildState(value: Object|NewChildData) {
        const newChild = Object.assign({}, this.state.newChild, value);
        this.setState({ newChild });
    }

    private copy(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        this.setState({ validation: true }, () => {
            if (document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ isLoading: true });
                fetchApi(`api/Children/Copy/${this.props.match.params.childId}`, this.state.newChild, 'POST')
                    .then((response: { ChildID: number }) => {
                        this.props.history.push(`/child/${response.ChildID}`);
                    })
                    .catch((error: Error) => {
                        this.setState({ isLoading: false });
                        alert('Failed to copy!');
                    })
            }
        });
    }
}
